export default __webpack_public_path__ + "static/media/payer.7e7f62f4.svg";